(() => {
  const shopLoginButtonSelector =
    'customer-account-sheet shop-login-button';
  const boundButtons = new WeakSet();
  let authCheckPromise = null;

  const refreshIfAuthenticated = () => {
    const accountSheet = document.querySelector('customer-account-sheet');
    if (
      !accountSheet ||
      accountSheet.dataset.authenticated === 'true' ||
      authCheckPromise
    ) {
      return authCheckPromise;
    }

    authCheckPromise = (async () => {
      const requestUrl = new URL(window.location.href);
      const themeId = window.Shopify?.theme?.id;
      if (themeId) {
        requestUrl.searchParams.set('preview_theme_id', String(themeId));
      }
      requestUrl.searchParams.set(
        '_account_sheet_auth_check',
        String(Date.now())
      );

      const response = await fetch(requestUrl.toString(), {
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      });
      if (!response.ok) return;

      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');
      if (
        nextDocument.querySelector(
          'customer-account-sheet[data-authenticated="true"]'
        )
      ) {
        window.location.reload();
      }
    })()
      .catch(() => {})
      .finally(() => {
        authCheckPromise = null;
      });

    return authCheckPromise;
  };

  const onShopLoginCompleted = (event) => {
    if (event.detail?.loggedIn === true) {
      window.location.reload();
      return;
    }

    void refreshIfAuthenticated();
  };

  const bindShopLoginButtons = () => {
    document.querySelectorAll(shopLoginButtonSelector).forEach((button) => {
      if (boundButtons.has(button)) return;

      boundButtons.add(button);
      button.addEventListener('completed', onShopLoginCompleted);
      button.addEventListener('windoidclosed', refreshIfAuthenticated);
    });
  };

  bindShopLoginButtons();
  new MutationObserver(bindShopLoginButtons).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
